import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MapDialogLayout from './MapDialogLayout';

/**
 * MapDialog opens a map with markers
 *
 * MapDialog takes arrays of records, projects, resources and addresses, and marks them on the map
 * To give just one record, props should be records={[someRecord]}
 * mapType can be "hybrid", "roadMap", "satellite", or null
 */
function MapDialog(props) {
  return (
    <MapDialogLayout
      onClose={props.onClose}
      records={props.records}
      projects={props.projects}
      resources={props.resources}
      addresses={props.addresses}
      mapType={props.mapType}

      selectPositionMode={props.selectPositionMode}
      handleSelectPosition={props.handleSelectPosition}
      defaultSelectedPosition={props.defaultSelectedPosition}

      drawCircleMode={props.drawCircleMode}
      handleCircleRadius={props.handleCircleRadius}
      defaultRadius={props.defaultRadius}

      drawAreaMode={props.drawAreaMode}
      handleDrawArea={props.handleDrawArea}
      defaultArea={props.defaultArea}
    />
  );
}

MapDialog.defaultProps = {};

MapDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  records: PropTypes.array,
  projects: PropTypes.array,
  resources: PropTypes.array,
  addresses: PropTypes.array,
  mapType: PropTypes.string,

  selectPositionMode: PropTypes.bool,
  handleSelectPosition: PropTypes.func,
  defaultSelectedPosition: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),

  drawCircleMode: PropTypes.bool,
  handleCircleRadius: PropTypes.func,
  defaultRadius: PropTypes.number,

  drawAreaMode: PropTypes.bool,
  handleDrawArea: PropTypes.func,
  defaultArea: PropTypes.array,
};

export default MapDialog;
